// Types of action taken by AI
export const actionTypes = {
  word: 'word',
  phrase: 'phrase',
  WORD_PREP: 'WORD_PREP', // currently, calculating pause time
};

//Types of ending errors in a word
export const wordEndingErrorType = {
  ADDED: 'added',
  DROPPED: 'dropped',
  MIX: 'mix',
};

export const NO_RESPONSE = 'NO_RESPONSE_EMPTY';

//Types of Users
export const userTypes = {
  TEACHER: 'teacher',
  STUDENT: 'student',
  SCHOOL_ADMIN: 'SCHOOL_ADMIN',
  DISTRICT_ADMIN: 'DISTRICT_ADMIN',
};

//Type of Questions, used for Quiz Component
export const QUESTION_TYPE = {
  CLOZE: 'cloze',
  MULTI: 'multi',
};

// Benchmark Report - Filter
export const ASSESSMENT_TYPE_FILTERS = {
  BENCHMARK_ONLY: "BENCHMARK_ONLY",
  MOST_RECENT_ASSESSMENT: "MOST_RECENT_ASSESSMENT",
}

// Reader Manager Reading Modes
export const READING_MODES = {
  TUTOR: "tutor",
  ASSESSMENT: "assessment",
}

//Type of Assignment
export const assignmentTypes = {
  ASSESSMENT: 'assessment',
  TUTOR: 'tutor',
  DYSLEXIA: 'dyslexia',
  NWF: 'nwf',
  SPELLING: 'spelling',
  LISTENING_COMPREHENSION: 'listeningComprehension',
  READING_COMPREHENSION: 'readingComprehension',
  VOCABULARY_SCREENER: 'vocabularyScreener',
  LETTER_NAMING_AND_SOUNDS: 'letterNamingAndSounds',
};

export const phraseTypes = {
  NONSENSE_WORD_REPETITION: 'nonsenseWordRepetition',
  CHANGE_ONE_PART: 'changeOnePart',
  WORD_PART_DELETION: 'wordPartDeletion',
  UP_AND_DOWN: 'upAndDown',
  LETTER_FLIES: 'letterFlies',
  ELKONIN: 'elkonin',
}

export const PhraseTriggers = {
  Submit: 'submit',
  Letters: 'letters',
  Repeat: 'repeat',
  Backspace: 'backspace',
  Start: 'start',
  Ready: 'ready',
  Split: 'split',
}

//Activity status
export const activityStatus = {
  ASSIGNED: 'assigned',
  SCORING_NOT_STARTED: 'not_started',
  SCORING_IN_PROGRESS: 'in_progress',
  SCORED: 'scored',
  RESCORED: 'rescored',
  ABORTED: 'aborted',
  COMPLETED: 'completed',
  UNDER_REVIEW: 'underReview',
  ARCHIVED: 'archived',
}

// Used for Diagnostic Report
export const SEQUENCE_STATUS = {
  NOT_STARTED: "NOT_STARTED",
  IN_PROGRESS: "IN_PROGRESS",
  NEXT_UP: "NEXT_UP",
  COMPLETED: "COMPLETED",
  ADDITIONAL_PRACTICE: "ADDITIONAL_PRACTICE",
};

// Type of Sequence for Diagnostic Report
export const STORY_SEQUENCE_TYPES = {
  ERSS: "ERSS",
};

// This constant influences available M/S/B.
// Most reports have type default.
// Currently, all admin reports only have ORF available.
// Dyslexia report has a unique M/S/B.
export const msbType = {
  DEFAULT: 'DEFAULT',
  ORF: 'ORF',
  DYSLEXIA: 'DYSLEXIA',
  COMPREHENSIVE: 'COMPREHENSIVE',
}

export const contentTags = {
  PICTURE_STORY: 'PICTURE_STORY',
  EARLY_READER_WORD_LIST: 'EARLY_READER_WORD_LIST',
  EARLY_READER_READ_WITH_ME: 'EARLY_READER_READ_WITH_ME',
  EARLY_READER_REPETITIVE_TEXT: 'EARLY_READER_REPETITIVE_TEXT',
  EARLY_READER_SEQUENCE_END: 'EARLY_READER_SEQUENCE_END',
  SAXON_SEQUENCE_END: 'SAXON_SEQUENCE_END',
  SAXON_STORY: 'hmh-saxon',
  CHANGE_ONE_PART: 'CHANGE_ONE_PART',
  WORD_PART_DELETION: 'WORD_PART_DELETION',
  EARLY_READER_CHANGE_ONE_PART: 'EARLY_READER_CHANGE_ONE_PART',
  EARLY_READER_UP_AND_DOWN: 'EARLY_READER_UP_AND_DOWN',
  EARLY_READER_LETTER_FLIES: 'EARLY_READER_LETTER_FLIES',
  EARLY_READER_ELKONIN_BOXES: 'EARLY_READER_ELKONIN_BOXES',
  EARLY_READER_ELKONIN: 'EARLY_READER_ELKONIN',
}

export const earlyReaderContentTagsNoEdm = [
  contentTags.EARLY_READER_LETTER_FLIES,
  contentTags.EARLY_READER_CHANGE_ONE_PART,
  contentTags.EARLY_READER_ELKONIN,
  contentTags.EARLY_READER_UP_AND_DOWN
]

export const recommendationModes = {
  SEQUENCE_LOCKED: 'SEQUENCE_LOCKED',
  SEQUENCE_EXPIRES: 'SEQUENCE_EXPIRES',
  NO_SEQUENCE: 'NO_SEQUENCE',
}

export const locales = {
  EN_US: 'EN-US',
  ES_MX: 'ES-MX',
}

export const localesUnderscoreMap = {
  "EN-US": "EN_US",
  "ES-MX": "ES_MX",
}

export const i18nLabels = {
  "en": "English",
  "es": "Spanish",
};

export const i18nOptions = [
  {value: "en", label: "English"},
  {value: "es", label: "Spanish"},
];

export const SPANISHCONFIG ={
  englishOnly: "ENGLISH_ONLY",
  spanishOnly: "SPANISH_ONLY",
  bothOneSession: "BOTH_ONE_SESSION",
  bothOneSessionEnglishFirst: "BOTH_ONE_SESSION_ENGLISH_FIRST",
  bothTwoSessions: "BOTH_TWO_SESSIONS",
  bothTwoSessionsEnglishFirst: "BOTH_TWO_SESSIONS_ENGLISH_FIRST"
}

// Map dimensions in world coordinates
export const mapSize = {
  width: 2048,
  height: 1152
};


export const WEBGL_ASSET_PATHS = {
  AMIRA_PATH: (GITHUB_PAGES_ROOT_PATH || "") + "/" + SPINES_PATH + "/Amira/Amira",
};

export const gameSFXKeys = {
  bringThatStory: "bringThatStory",
  robotMovement: "robotMovement",
  storyCraftMovement: "storyCraftMovement",
  backgroundMusicDuel: "backgroundMusicDuel",
  backgroundMusicGeneral: "backgroundMusicGeneral",
  backgroundMusicStorybot: "backgroundMusicStorybot",
  robotStealSound: "robotStealSound",
  robotStoryAcquired: "robotStoryAcquired",
  lowWordPowerAlert: "lowWordPowerAlert",
  outOfWordPower: "outOfWordPower",
  villainEndDuel: "villainEndDuel",
  villianGotcha:"gotcha",
  villainLevelUp: "villainLevelUp",
  robotEndDuel: "robotEndDuel",
  wpMeterEndDuel: "wpMeterEndDuel",
  wpPhraseEarn: "wpPhraseEnd",
  danceMusic: "danceMusic",
  pickFromTray: "pickFromTray",
  addSticker: "addSticker"
}

export const AUDIO_STATUS = {
  audioPlaying: 2,
  audioStopped: 4,
};